import { Injectable } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { FormService } from 'projects/builder-app/src/app/shared/services/form.service';
import { VOUCHER_HTML, VOUCHER_TYPES } from '../../../../constants/voucher';
import { AuthService } from 'projects/builder-app/src/app/core/services/auth.service';
import { REDEMPTION_VOUCHER_HTML, REDEMPTION_VOUCHER_HTML_DIRECTBET, REDEMPTION_VOUCHER_HTML_MATCHPLAY } from '../../../../constants/redemption-voucher';
import {
  redemptionInformationTemplate,
  redemptionV2InformationTemplate,
  reemtpionInformationCss,
  giftCardInformationTemplate,
  giftCardInformationCss,
} from 'projects/builder-app/src/app/core/constants/constants';
import { CMS_VOUCHER_HTML } from '../../../../constants/cms-offer-voucher';
import {
  GIFT_CARD_CONFIRM_HTML,
  GIFT_CARD_CONFIRM_CSS,
  GIFT_CARD_DONE_CSS,
  GIFT_CARD_DONE_HTML,
} from '../constants';

@Injectable({
  providedIn: 'root',
})
export class TemplateDialogFormService {
  constructor(
    private fb: FormBuilder,
    private formService: FormService,
    private authService: AuthService
  ) {}

  public createProfileForm() {
    return this.fb.group({
      icon: this.fb.group({
        iconName: new FormControl(''),
        iconColor: new FormControl(null),
        iconSize: new FormControl(null),
      }),
      name: this.formService.generateTwoCheckboxFormGroup(),
      nickName: this.formService.generateTwoCheckboxFormGroup(),
      primaryAddress: this.formService.generateTwoCheckboxFormGroup(),
      preferredAddress: this.formService.generateTwoCheckboxFormGroup(),
      email: this.fb.group({
        isVisible: new FormControl(null),
        isEditable: new FormControl(null),
        isNeedConfirmation: new FormControl(null),
        addEnabled: new FormControl(null),
        regex: new FormControl('/^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$/'.toString()),
        optOutEmailText: new FormControl('Opt-out of email marketing'),
      }),
      phoneNumber: this.fb.group({
        isVisible: new FormControl(null),
        isEditable: new FormControl(null),
        isNeedConfirmation: new FormControl(null),
        addEnabled: new FormControl(null),
        regex: new FormControl(
          '/\\(?([0-9]{3})\\)?([ .-]?)([0-9]{3})\\2([0-9]{4})/'.toString()
        ),
        optOutPhoneText: new FormControl('Opt-out of text marketing'),
      }),

      pin: this.formService.generateTwoCheckboxFormGroup(),
      clientMessage: new FormControl(''),
      emailConfirmationText: new FormControl(
        'Are you sure you want to change your email address?'
      ),
      phoneConfirmationText: new FormControl(
        'Are you sure you want to change your phone number?'
      ),
      emailOptOut: new FormControl(null),
      phoneOptOut: new FormControl(null),
      addressOptOut: new FormControl(null),
    });
  }

  public createWinLossForm() {
    return this.fb.group({
      title: this.fb.group({
        isVisible: new FormControl(true),
      }),
      currentYear: this.fb.group({
        isVisible: new FormControl(true),
      }),
      initialText: this.fb.group({
        titleText: new FormControl({
          value: 'Win/Loss Statement',
          disabled: false,
        }),
        textBefore: new FormControl(
          'Please Select the Year of Your Win/Loss Statement bellow'
        ),
        textAfter: new FormControl(
          'Your Win/Loss statement has been sent to the email on file'
        ),
        errorMessageAfterSubmit: new FormControl(
          'Oops! There was a problem processing your request. Please contact our help desk for assistance'
        ),
      }),
    });
  }

  public createRedemptionForm() {
    return this.fb.group({
      sourceBucket: new FormControl(null, Validators.required),
      sourceBucketTitle: new FormControl(null, Validators.required),
      conversionType: new FormControl(null, Validators.required),
      conversionTypeTitle: new FormControl(null, Validators.required),
      conversionRate: new FormControl('all'),
      rateFrom: new FormControl(null),
      rateTo: new FormControl(null),
      limits: new FormControl(0),
      dailyLimit: new FormControl(1),
      accountId: new FormControl(''),
      minValue: new FormControl(5),
      maxValue: new FormControl(2000),
      exchangeText: new FormControl('You are about to redeem'),
      showConversionValue: new FormControl(false),
      ivalidMinAmountTitle: new FormControl('Invalid amount'),
      ivalidMinAmountText: new FormControl(
        'The point value you are trying to redeem is below the minimum of ${{minAmount}}. Please try again.'
      ),
      ivalidMaxAmountTitle: new FormControl('Invalid amount'),
      ivalidMaxAmountText: new FormControl(
        'The point value you are trying to redeem exceeds the max limit of ${{maxAmount}}. Please try again.'
      ),
      description: this.fb.group({
        showHtmlBoxBorder: new FormControl(true),
        html: new FormControl(redemptionInformationTemplate),
        css: new FormControl(reemtpionInformationCss),
      }),
      explanation: this.fb.group({
        text: new FormControl(''),
        helpText: new FormControl(''),
      }),
      tiredConversionRate: this.fb.array([]),
      buttonsOption: new FormControl('tenKeyEntry'),
      preSets: this.fb.array([]),
      isPrintVoucherRequired: new FormControl(false),
    });
  }

  public createPdfForm() {
    return this.fb.group({
      url: new FormControl(null),
      fileUrl: new FormControl(null),
      fileName: new FormControl(null),
    });
  }

  public createGiftCardForm() {
    return this.fb.group({
      sourceBucket: new FormControl(null, Validators.required),
      conversionRate: new FormControl('all'),
      rateFrom: new FormControl(null),
      rateTo: new FormControl(null),
      limits: new FormControl(0),
      description: this.fb.group({
        showHtmlBoxBorder: new FormControl(true),
        html: new FormControl(giftCardInformationTemplate),
        css: new FormControl(giftCardInformationCss),
      }),
      explanation: this.fb.group({
        text: new FormControl(''),
      }),
      tiredConversionRate: this.fb.array([]),
      buttonsOption: new FormControl('tenKeyEntry'),
      preSets: this.fb.array([]),
      accountIdentifier: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
      beginYourPurchase: new FormControl('Begin your purchase'),
      yourPointBalance: new FormControl('Your Point Balance:'),
      enterAmount: new FormControl('Enter Gift Card amount:'),
      canEditEmail: new FormControl(false),
      utid: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
      qrUrl: new FormControl(null, [
        Validators.required,
        Validators.minLength(3),
      ]),
      qrCodeTitle: new FormControl('Want to view the catalog first?'),
      qrCodeText: new FormControl(
        'Scan the QR code to view the gift card catalog.'
      ),
      minValue: new FormControl(5),
      maxValue: new FormControl(2000, [
        Validators.min(1),
        Validators.max(2000),
      ]),
      ivalidMinAmountTitle: new FormControl('Invalid amount'),
      ivalidMinAmountText: new FormControl(
        'The point value you are trying to redeem is below the minimum of ${{minAmount}}. Please try again.'
      ),
      ivalidMaxAmountTitle: new FormControl('Invalid amount'),
      ivalidMaxAmountText: new FormControl(
        'The point value you are trying to redeem exceeds the max limit of ${{maxAmount}}. Please try again.'
      ),
      confirmTextHtml: new FormControl(GIFT_CARD_CONFIRM_HTML),
      confirmTextCss: new FormControl(GIFT_CARD_CONFIRM_CSS),
      doneTextHtml: new FormControl(GIFT_CARD_DONE_HTML),
      doneTextCss: new FormControl(GIFT_CARD_DONE_CSS),
      missingEmailTitle: new FormControl('Missing email'),
      missingEmailText: new FormControl(
        'You do not have an email on file. The transaction cannot be completed. Please visit the Player’s Club to update your account email address.'
      ),
    });
  }

  public createMainConfigurationForm() {
    const fs = this.formService;
    return this.fb.group({
      main: this.fb.group({
        title: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
      }),
    });
  }

  public createWebPageForm() {
    return this.fb.group({
      url: new FormControl('', Validators.required),
    });
  }

  public createDrawingPageForm() {
    return this.fb.group({
      displaySettings: this.fb.group({
        showMultipliers: new FormControl(true),
        showFreeEntries: new FormControl(true),
        showDrawings: new FormControl(true),
        showTierEntries: new FormControl(true),
      }),
    });
  }

  public createOffersForm() {
    return this.fb.group(this.createDefaultOfferConfiguration());
  }

  public createOffersAndDrawingsPageForm() {
    return this.fb.group({
      ...this.createDefaultOfferConfiguration(),
      displaySettings: this.fb.group({
        showMultipliers: new FormControl(true),
        showFreeEntries: new FormControl(true),
        showDrawings: new FormControl(true),
        showTierEntries: new FormControl(true),
      }),
    });
  }

  public createOffersAndOffersCmsForm() {
    return this.fb.group({
      ...this.createDefaultOfferConfiguration(),
      fieldToMatch: new FormControl('description'),
    });
  }

  public createOffersCmsOffersAndDrawingsForm() {
    return this.fb.group({
      ...this.createDefaultOfferConfiguration(),
      fieldToMatch: new FormControl('description'),
      displaySettings: this.fb.group({
        showMultipliers: new FormControl(true),
        showFreeEntries: new FormControl(true),
        showDrawings: new FormControl(true),
        showTierEntries: new FormControl(true),
      }),
    });
  }

  public createOffersCmsOffersAndDrawingsTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noItemsText: new FormControl('There are currently no items available.'),
        noItems: this.formService.generateTextInputsConfig(),
        noOffers: this.formService.generateTextInputsConfig(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        redeemedOfferImage: this.fb.group({
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.offerPageButtonsFormGroup(),
        redeemedOfferDisplaySettings: this.fb.group({
          removeFromDisplay: new FormControl(false),
          isWatermarkAdded: new FormControl(false),
          isWatermarkOverOffer: new FormControl(false),
          isWatermarkOverOfferAndDetails: new FormControl(false),
          isGrayscaled: new FormControl(false),
          canOpenDetails: new FormControl(false),
        }),
      }),
      cardDrawing: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(true),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivateDisabled: this.formService.buttonFormGroup(),
        buttonActivateDisabledText: new FormControl('Activate'),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardFreeEntry: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardTierEntry: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardMultiplier: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      drawingDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        closeButtonCheck: this.fb.group({
        isOnOffMode: new FormControl(true),
      }),
        title: this.formService.generateTextInputsConfig(),
        date: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
        sliderButtonActivate: this.formService.buttonFormGroup(),
        sliderButtonInactive: this.formService.buttonFormGroup(),
        sliderText: this.formService.generateTextInputsConfig(),
      }),
      freeEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      tierEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      multiplierDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardOffer: this.createCardOffer(),
      cardOfferDetails: this.createCardOfferDetails(),
      breakdown: this.fb.group({
        selectButton: this.buttonsFormGroup(),
        goBackButton: this.buttonsFormGroup(),
        outlineColour: this.buttonsFormGroup(),
        buttonBreakValueTitle: new FormControl('How would you like your offer broken down?'),
        font: this.formService.generateTextInputsConfig()
      }),
      mysteryOffer: this.createMysteryOffer(),
      riskOffer: this.createRiskOffer(),
      chooseOffer: this.createChooseOffer(),
      swapOffer: this.createSwapOffer(),
      swapOfferCms: this.createSwapOfferCms(),
      voucher: this.fb.group({
        type: new FormControl(VOUCHER_TYPES[0]),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),
        html: new FormControl(
          VOUCHER_HTML(this.authService.userData.clientName)
        ),
        cmsHtml: new FormControl(
          CMS_VOUCHER_HTML(this.authService.userData.clientName)
        ),
      }),
      welcomePopUp: this.fb.group({
        isEnabled: new FormControl(false),
        schedule: new FormControl('0'),
        weekdaySchedule: this.fb.group({
          isEnabled: new FormControl(false),
          selectedDays: new FormControl([]),
        }),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        message: new FormControl(''),
        messageStyle: this.formService.generateTextInputsConfig(),
        buttonText: new FormControl(''),
        button: this.formService.buttonFormGroup(),
      }),
    });
  }

  public createOffersCmsForm() {
    return this.fb.group({
      displayType: new FormControl('Icons'),
      configuration: new FormControl('Square'),
      fieldToMatch: new FormControl('description'),
      isNeedToCloseAfterPrint: new FormControl(true),
      hideExpiredCampaigns: new FormControl(false)
    });
  }

  public createDrawingCmsForm() {
    return this.fb.group({
      displayType: new FormControl('Icons'),
      configuration: new FormControl('Square'),
      fieldToMatch: new FormControl('description'),
      openDetailedView: this.fb.group({
        isVisible: new FormControl(true),
      }),
    });
  }

  public createJoingoDrawingForm() {
    return this.fb.group({});
  }

  public createProfileTemplateConfigurations() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        clientMessage: this.formService.generateTextInputsConfig(),
        text: this.formService.generateTextInputsConfig(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        optOut: this.fb.group({
          text: this.formService.generateTextInputsConfig(),
          backgroundColor: this.fb.group({
            checked: new FormControl(null),
            unchecked: new FormControl(null),
          }),
          border: this.formService.borderFormGroup(),
          checkmarkColor: new FormControl(null),
        }),
      }),
      inputs: this.fb.group({
        mainConfig: this.fb.group({
          size: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        backgroundColor: this.fb.group({
          default: new FormControl(null),
          active: new FormControl(null),
          error: new FormControl(null),
        }),
        borderColor: this.fb.group({
          default: new FormControl(null),
          active: new FormControl(null),
          error: new FormControl(null),
        }),
        title: this.formService.generateTextInputsConfig(),
        text: this.formService.generateTextInputsConfig(),
        placeholder: this.formService.generateTextInputsConfig(),
        errorText: this.formService.generateTextInputsConfig(),
        // this.fb.group({})
      }),
      buttons: this.fb.group({
        primaryButtons: this.buttonsFormGroup(),
        secondaryButtons: this.buttonsFormGroup(),
        editButton: this.buttonsFormGroup(),
        innerText: new FormControl('More'),
        editButtonIcon: this.fb.group({
          iconName: new FormControl(''),
          iconColor: new FormControl(null),
          iconSize: new FormControl(null),
        }),
      }),
      popUp: this.fb.group({
        style: new FormControl('At the bottom of the screen'),
        messageText: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        overlay: new FormControl(),
        buttonConfirm: this.formService.buttonFormGroup(),
        buttonCancel: this.formService.buttonFormGroup(),
      }),
    });
  }

  private buttonsFormGroup(): FormGroup {
    return this.fb.group({
      buttonStyle: new FormControl(null),
      text: this.formService.generateTextInputsConfig(),
      border: this.fb.group({
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
        color: new FormControl(null),
      }),
      background: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
    });
  }

  private offerPageButtonsFormGroup(): FormGroup {
    return this.fb.group({
      textSelected: this.formService.generateTextInputsConfig(),
      textUnselected: this.formService.generateTextInputsConfig(),
      border: this.fb.group({
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
        color: new FormControl(null),
      }),
      background: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
    });
  }

  private drawingPageButtonsFormGroup(): FormGroup {
    return this.fb.group({
      textSelected: this.formService.generateTextInputsConfig(),
      textUnselected: this.formService.generateTextInputsConfig(),
      border: this.fb.group({
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
        color: new FormControl(null),
      }),
      background: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
    });
  }
// redemption V2
  public createRedemptionV2TemplateConfiguration() {
    const fs = this.formService;
    return this.fb.group({
      main: this.fb.group({
        title: fs.generateTextInputsConfig(),
        testTitle: fs.generateTextInputsConfig(),
        dropdown: fs.generateDropDownConfig(),
        showSelectButton: new FormControl(false),
        background: fs.backgroundFormGroup(),
        explanation: fs.generateTextInputsConfig(),
        amountExplanation: this.fb.group({
          number: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      modal: this.fb.group({
        closeButton: fs.buttonFormGroup(),
        isCloseOnOffMode: new FormControl(true),
        tabButtonRedeemRisk: fs.buttonFormGroup(),
        modalBackground: fs.backgroundFormGroup(),
        isTabButtonsAllowed: new FormControl(true),
        arrowButton: fs.arrowButtonFormGroup(),
        redeemModalTitle: fs.generateTextInputsConfig(),
        redeemModalTitleInput: new FormControl(
          'What would you like to redeem for?'
        ),
        redeemCardBackground: fs.backgroundFormGroup(),
        redeemCardTitle: fs.generateTextInputsConfig(),
      }),
      dataPoints: this.fb.group({
        titlePoints: fs.generateTextInputsConfig(),
        value: fs.generateTextInputsConfig(),
        border: fs.borderFormGroup(),
        background: fs.backgroundFormGroup(),
      }),
      preSets: this.fb.group({
        amountButton: fs.buttonFormGroup(),
        addButton: fs.buttonFormGroup(),
        disabledAddButton: fs.buttonFormGroup(),
        removeButton: fs.buttonFormGroup(),
        disabledremoveButton: fs.buttonFormGroup(),
        maxAmountButton: fs.buttonFormGroup(),
        inputAmount: this.fb.group({
          inputSettings: this.fb.group({
            borderRadius: new FormControl(),
            borderWidth: new FormControl(),
            backgroundColor: new FormControl(),
            borderColor: new FormControl(),
          }),
          title: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      freeEntry: this.fb.group({
        numeralButton: fs.buttonFormGroup(),
        deleteButton: fs.buttonFormGroup(),
        deleteButtonIcon: this.fb.group({
          iconName: new FormControl(''),
          iconColor: new FormControl(null),
          iconSize: new FormControl(null),
        }),
        confirmationButton: fs.buttonFormGroup(),
        inputAmount: this.fb.group({
          inputSettings: this.fb.group({
            borderRadius: new FormControl(),
            borderWidth: new FormControl(),
            backgroundColor: new FormControl(),
            borderColor: new FormControl(),
          }),
          title: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      buttons: this.fb.group({
        butonsConfirm: fs.buttonFormGroup(),
        buttonsCancel: fs.buttonFormGroup(),
        buttonsClearAll: fs.buttonFormGroup(),
      }),
      popUp: this.fb.group({
        style: new FormControl('At the bottom of the screen'),
        messageText: fs.generateTextInputsConfig(),
        accentMessageText: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        overlay: new FormControl(),
        buttonConfirm: fs.buttonFormGroup(),
        buttonCancel: fs.buttonFormGroup(),
      }),
      voucher: this.fb.group({
        expirationDays: new FormControl(0),
        html: new FormControl(
          REDEMPTION_VOUCHER_HTML(this.authService.userData.clientName)
        ),

        htmlDirectBet: new FormControl(
          REDEMPTION_VOUCHER_HTML_DIRECTBET(this.authService.userData.clientName)
        ),
        htmlMatchPlay: new FormControl(
          REDEMPTION_VOUCHER_HTML_MATCHPLAY(this.authService.userData.clientName)
        ),

        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),

        printOnScreen: this.fb.group({
          isTestMode: new FormControl(false),
        })
      }),
    });
  }

  public createRedemptionTemplateConfiguration() {
    const fs = this.formService;
    return this.fb.group({
      main: this.fb.group({
        title: fs.generateTextInputsConfig(),
        testTitle: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        explanation: fs.generateTextInputsConfig(),
        amountExplanation: this.fb.group({
          number: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      dataPoints: this.fb.group({
        titlePoints: fs.generateTextInputsConfig(),
        value: fs.generateTextInputsConfig(),
        border: fs.borderFormGroup(),
        background: fs.backgroundFormGroup(),
      }),
      preSets: this.fb.group({
        amountButton: fs.buttonFormGroup(),
        addButton: fs.buttonFormGroup(),
        disabledAddButton: fs.buttonFormGroup(),
        removeButton: fs.buttonFormGroup(),
        disabledremoveButton: fs.buttonFormGroup(),
        maxAmountButton: fs.buttonFormGroup(),
        inputAmount: this.fb.group({
          inputSettings: this.fb.group({
            borderRadius: new FormControl(),
            borderWidth: new FormControl(),
            backgroundColor: new FormControl(),
            borderColor: new FormControl(),
          }),
          title: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      freeEntry: this.fb.group({
        numeralButton: fs.buttonFormGroup(),
        deleteButton: fs.buttonFormGroup(),
        deleteButtonIcon: this.fb.group({
          iconName: new FormControl(''),
          iconColor: new FormControl(null),
          iconSize: new FormControl(null),
        }),
        confirmationButton: fs.buttonFormGroup(),
        inputAmount: this.fb.group({
          inputSettings: this.fb.group({
            borderRadius: new FormControl(),
            borderWidth: new FormControl(),
            backgroundColor: new FormControl(),
            borderColor: new FormControl(),
          }),
          title: fs.generateTextInputsConfig(),
          text: fs.generateTextInputsConfig(),
        }),
      }),
      buttons: this.fb.group({
        butonsConfirm: fs.buttonFormGroup(),
        buttonsCancel: fs.buttonFormGroup(),
        buttonsClearAll: fs.buttonFormGroup(),
      }),
      popUp: this.fb.group({
        style: new FormControl('At the bottom of the screen'),
        messageText: fs.generateTextInputsConfig(),
        accentMessageText: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        overlay: new FormControl(),
        buttonConfirm: fs.buttonFormGroup(),
        buttonCancel: fs.buttonFormGroup(),
      }),
      voucher: this.fb.group({
        expirationDays: new FormControl(0),
        html: new FormControl(
          REDEMPTION_VOUCHER_HTML(this.authService.userData.clientName)
        ),
        printOnScreen: this.fb.group({
          isTestMode: new FormControl(false),
        }),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),
      }),
    });
  }

  public createWinAndLossConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        yearDropdown: this.formService.generateDropDownConfig(),
        background: this.formService.backgroundFormGroup(),
        borderColor: this.formService.borderFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        textBefore: this.formService.generateTextInputsConfig(),
        textAfter: this.formService.generateTextInputsConfig(),
        errorMessageAfterSubmit: this.formService.generateTextInputsConfig(),
      }),
      inputs: this.fb.group({
        mainConfig: this.fb.group({
          size: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        background: this.formService.backgroundFormGroup(),
        borderColor: this.formService.borderFormGroup(),
        titleWL: this.formService.generateTextInputsConfig(),
        textBefore: this.formService.generateTextInputsConfig(),
        textAfter: this.formService.generateTextInputsConfig(),
        errorMessageAfterSubmit: this.formService.generateTextInputsConfig(),
      }),
      buttons: this.fb.group({
        primaryButtons: this.buttonsFormGroup(),
        innerTextButton: new FormControl('Submit Year'),
      }),
    });
  }

  public createGiftCardTemplateConfiguration() {
    return this.createRedemptionTemplateConfiguration();
  }

  public createDrawingTemplateConfiguration() {
    const fs = this.formService;
    return this.fb.group({
      main: this.fb.group({
        title: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        noDrawingsText: new FormControl(
          'There are currently no drawings available.'
        ),
        noDrawingTextConfig: fs.generateTextInputsConfig(),
      }),
      cardDrawing: this.fb.group({
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        shadow: fs.shadowFormGroup(),
        buttonDetail: fs.buttonFormGroup(true),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivateDisabled: fs.buttonFormGroup(),
        buttonActivateDisabledText: new FormControl('Activate'),
        buttonActivated: fs.buttonFormGroup(),
      }),
      cardFreeEntry: this.fb.group({
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        shadow: fs.shadowFormGroup(),
        buttonDetail: fs.buttonFormGroup(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      cardTierEntry: this.fb.group({
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        shadow: fs.shadowFormGroup(),
        buttonDetail: fs.buttonFormGroup(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      cardMultiplier: this.fb.group({
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        border: fs.borderFormGroup(),
        shadow: fs.shadowFormGroup(),
        buttonDetail: fs.buttonFormGroup(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      drawingDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: fs.generateTextInputsConfig(),
        date: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        imageBorder: fs.borderFormGroup(),
        detailBackground: fs.backgroundFormGroup(),
        detailBorder: fs.borderFormGroup(),
        detailEntry: fs.generateTextInputsConfig(),
        detailText: fs.generateTextInputsConfig(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
        sliderButtonActivate: fs.buttonFormGroup(),
        sliderButtonInactive: fs.buttonFormGroup(),
        sliderText: fs.generateTextInputsConfig(),
      }),
      freeEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        imageBorder: fs.borderFormGroup(),
        detailBackground: fs.backgroundFormGroup(),
        detailBorder: fs.borderFormGroup(),
        detailEntry: fs.generateTextInputsConfig(),
        detailText: fs.generateTextInputsConfig(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      tierEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        imageBorder: fs.borderFormGroup(),
        detailBackground: fs.backgroundFormGroup(),
        detailBorder: fs.borderFormGroup(),
        detailEntry: fs.generateTextInputsConfig(),
        detailText: fs.generateTextInputsConfig(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      multiplierDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: fs.generateTextInputsConfig(),
        description: fs.generateTextInputsConfig(),
        background: fs.backgroundFormGroup(),
        imageBorder: fs.borderFormGroup(),
        detailBackground: fs.backgroundFormGroup(),
        detailBorder: fs.borderFormGroup(),
        detailEntry: fs.generateTextInputsConfig(),
        detailText: fs.generateTextInputsConfig(),
        buttonActivate: fs.buttonFormGroup(),
        buttonActivated: fs.buttonFormGroup(),
      }),
      welcomePopUp: this.fb.group({
        isEnabled: new FormControl(false),
        schedule: new FormControl('0'),
        weekdaySchedule: this.fb.group({
          isEnabled: new FormControl(false),
          selectedDays: new FormControl([]),
        }),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        message: new FormControl(''),
        messageStyle: this.formService.generateTextInputsConfig(),
        buttonText: new FormControl(''),
        button: this.formService.buttonFormGroup(),
      }),
    });
  }

  public createCmsOffersTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noOffersText: new FormControl(
          'There are currently no offers available.'
        ),
        noOffers: this.formService.generateTextInputsConfig(),
        redeemedOfferImage: this.fb.group({
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        redeemedOfferDisplaySettings: this.fb.group({
          removeFromDisplay: new FormControl(false),
          isWatermarkAdded: new FormControl(false),
          isWatermarkOverOffer: new FormControl(false),
          isWatermarkOverOfferAndDetails: new FormControl(false),
          isGrayscaled: new FormControl(false),
          canOpenDetails: new FormControl(false),
        }),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.offerPageButtonsFormGroup(),
      }),
      cardOffer: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        upcomingOfferTitleColor: new FormControl(null),
        diagonalLabelButton: this.buttonsFormGroup(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        border: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        buttonOfferDetailsText: new FormControl('Offer detail'),
        buttonOfferDetails: this.buttonsFormGroup(),
      }),
      cardOfferDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        isCloseOnOffMode: new FormControl(true),
        title: this.formService.generateTextInputsConfig(),
        text: this.formService.generateTextInputsConfig(),
        printDescription: this.formService.generateTextInputsConfig(),
        validTillPrefix: new FormControl('Valid till:'),

        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        buttonBreakValueText: new FormControl('Break Value'),
        buttonRedeemOfferText: new FormControl('Redeem'),
        buttonPrintOfferText: new FormControl('Print'),
        buttonPrintOffer: this.buttonsFormGroup(),
        redeemOfferButton: this.buttonsFormGroup(),
        buttonBreakValue: this.buttonsFormGroup(),
        border: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        imageBorder: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        buttonSection: this.fb.group({
          background: this.fb.group({
            color: new FormControl(null),
            imageLink: new FormControl(null),
            imageName: new FormControl(null),
          }),
          border: this.fb.group({
            borderColor: new FormControl(null),
            borderRadius: new FormControl(null),
            borderWidth: new FormControl(null),
          }),
        }),
      }),
      swapOfferCms: this.createSwapOfferCms(),
      breakdown: this.fb.group({
        selectButton: this.buttonsFormGroup(),
        goBackButton: this.buttonsFormGroup(),
        outlineColour: this.buttonsFormGroup(),
        buttonBreakValueTitle: new FormControl('How would you like your offer broken down?'),
        font: this.formService.generateTextInputsConfig()
      }),
      voucher: this.fb.group({
        type: new FormControl(VOUCHER_TYPES[1]),
        html: new FormControl(
          CMS_VOUCHER_HTML(this.authService.userData.clientName)
        ),
        voucherImage: this.fb.group({
          background: this.fb.group({
            color: new FormControl(null),
            imageLink: new FormControl(null),
            imageName: new FormControl(null),
          }),
          border: this.fb.group({
            borderColor: new FormControl(null),
            borderRadius: new FormControl(null),
            borderWidth: new FormControl(null),
          }),
        }),

        printOnScreen: this.fb.group({
          isTestMode: new FormControl(false),
        }),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        })
      }),
    });
  }

  public createRedemptionV2Form() {
    return this.fb.group({
      sourceBucket: new FormControl(null, Validators.required),
      sourceBucketTitle: new FormControl(null, Validators.required),
      conversionRate: new FormControl('all'),
      rateFrom: new FormControl(null),
      rateTo: new FormControl(null),
      limits: new FormControl(0),
      minValue: new FormControl(5),
      maxValue: new FormControl(2000),
      dailyLimit: new FormControl(1),
      accountId: new FormControl(''),
      exchangeText: new FormControl('You are about to redeem'),
      showConversionValue: new FormControl(false),
      ivalidMinAmountTitle: new FormControl('Invalid amount'),
      ivalidMinAmountText: new FormControl(
        'The point value you are trying to redeem is below the minimum of ${{minAmount}}. Please try again.'
      ),
      ivalidMaxAmountTitle: new FormControl('Invalid amount'),
      ivalidMaxAmountText: new FormControl(
        'The point value you are trying to redeem exceeds the max limit of ${{maxAmount}}. Please try again.'
      ),
      description: this.fb.group({
        showHtmlBoxBorder: new FormControl(true),
        html: new FormControl(redemptionV2InformationTemplate),
        css: new FormControl(reemtpionInformationCss),
      }),
      explanation: this.fb.group({
        text: new FormControl(''),
        helpText: new FormControl(''),
      }),
      tiredConversionRate: this.fb.array([]),
      buttonsOption: new FormControl('tenKeyEntry'),
      preSets: this.fb.array([]),
      isPrintVoucherRequired: new FormControl(false),
      //Legacy redemption options
      // showFreeSlot: new FormControl(false),
      // showMatchPlay: new FormControl(false),
      // showDirectBet: new FormControl(false),
      // inputFreeSlot: new FormControl('Free Slot Play'),
      // inputMatchPlay: new FormControl('Match Play'),
      // inputDirectBet: new FormControl('Direct Bet'),

      redeemOptions: this.fb.array([]),
      
      prefix: new FormControl('$'),
      suffix: new FormControl('USD'),
    });
  }

  public createCmsDrawingTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noDrawingText: new FormControl(
          'There are currently no Drawings available.'
        ),
        noDrawing: this.formService.generateTextInputsConfig(),

        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.drawingPageButtonsFormGroup(),
      }),
      cardDrawing: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        upcomingDrawingTitleColor: new FormControl(null),
        diagonalLabelButton: this.buttonsFormGroup(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        balance: new FormControl('Current Balance: '),
        balanceText: this.formService.generateTextInputsConfig(),
        border: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        buttonDrawingDetailsText: new FormControl('Drawing detail'),
        buttonDrawingDetails: this.buttonsFormGroup(),
      }),
      cardDrawingDetails: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        text: this.formService.generateTextInputsConfig(),
        printDescription: this.formService.generateTextInputsConfig(),
        balanceDetail: new FormControl('Current Balance: '),
        balanceDetailText: this.formService.generateTextInputsConfig(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        border: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        imageBorder: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        buttonSection: this.fb.group({
          background: this.fb.group({
            color: new FormControl(null),
            imageLink: new FormControl(null),
            imageName: new FormControl(null),
          }),
          border: this.fb.group({
            borderColor: new FormControl(null),
            borderRadius: new FormControl(null),
            borderWidth: new FormControl(null),
          }),
        }),
        closeButton: this.formService.buttonFormGroup(),
      }),
    });
  }

  public createJoingoDrawingTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noDrawingText: new FormControl(
          'There are currently no Drawings available.'
        ),
        errorActivateDrawingText: new FormControl(
          'There was a problem processing the request. Please contact help desk for assistance.'
        ),
        noDrawing: this.formService.generateTextInputsConfig(),

        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.drawingPageButtonsFormGroup(),
      }),
      cardDrawing: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        upcomingDrawingTitleColor: new FormControl(null),
        diagonalLabelButton: this.buttonsFormGroup(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        balance: new FormControl('Current Balance: '),
        balanceText: this.formService.generateTextInputsConfig(),
        border: this.fb.group({
          borderColor: new FormControl(null),
          borderRadius: new FormControl(null),
          borderWidth: new FormControl(null),
        }),
        buttonPreActiveText: new FormControl('PreActive'),
        buttonPreActive: this.buttonsFormGroup(),

        buttonActivateText: new FormControl('Activate'),
        buttonActivate: this.buttonsFormGroup(),

        buttonActivatedText: new FormControl('Activated'),
        buttonActivated: this.buttonsFormGroup(),
      }),
    });
  }

  public createOffersTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noOffersText: new FormControl(
          'There are currently no offers available.'
        ),
        noOffers: this.formService.generateTextInputsConfig(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.offerPageButtonsFormGroup(),
      }),
      cardOffer: this.createCardOffer(),
      cardOfferDetails: this.createCardOfferDetails(),
      mysteryOffer: this.createMysteryOffer(),
      riskOffer: this.createRiskOffer(),
      chooseOffer: this.createChooseOffer(),
      swapOffer: this.createSwapOffer(),
      voucher: this.fb.group({
        type: new FormControl(VOUCHER_TYPES[0]),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),
        html: new FormControl(
          VOUCHER_HTML(this.authService.userData.clientName)
        ),
      }),
    });
  }

  public createSwapOfferCms() {
    return this.fb.group({
      buttonTrade: new FormControl('Swap Offer'),
      buttonTradeConfig: this.buttonsFormGroup(),
      selectTitle: new FormControl('Select your new offer:'),
      selectTitleConfig: this.formService.generateTextInputsConfig(),
      buttonBack: new FormControl('Back'),
      buttonBackConfig: this.buttonsFormGroup(),
      buttonContinue: new FormControl('Continue'),
      buttonContinueConfig: this.buttonsFormGroup(),
      buttonContinueDisabledConfig: this.buttonsFormGroup(),
      activeImageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      inactiveImageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
    });
  }

  public createSwapOffer() {
    return this.fb.group({
      buttonTrade: new FormControl('Trade this Offer'),
      buttonTradeConfig: this.buttonsFormGroup(),
      selectTitle: new FormControl('Select your new offer:'),
      selectTitleConfig: this.formService.generateTextInputsConfig(),
      buttonContinue: new FormControl('Continue'),
      buttonContinueConfig: this.buttonsFormGroup(),
      buttonBack: new FormControl('Go Back'),
      buttonBackConfig: this.buttonsFormGroup(),
      buttonContinueDisableConfig: this.buttonsFormGroup(),
      confirmTitle: new FormControl('Confirmed'),
      confirmTitleConfig: this.formService.generateTextInputsConfig(),
    });
  }

  public createOffersAndOffersCmsTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noOffersText: new FormControl(
          'There are currently no offers available.'
        ),
        noOffers: this.formService.generateTextInputsConfig(),
        background: this.fb.group({
          color: new FormControl(null),
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        redeemedOfferImage: this.fb.group({
          imageLink: new FormControl(null),
          imageName: new FormControl(null),
        }),
        subpages: this.offerPageButtonsFormGroup(),
        redeemedOfferDisplaySettings: this.fb.group({
          removeFromDisplay: new FormControl(false),
          isWatermarkAdded: new FormControl(false),
          isWatermarkOverOffer: new FormControl(false),
          isWatermarkOverOfferAndDetails: new FormControl(false),
          isGrayscaled: new FormControl(false),
          canOpenDetails: new FormControl(false),
        }),
      }),
      cardOffer: this.createCardOffer(),
      cardOfferDetails: this.createCardOfferDetails(),
      breakdown: this.fb.group({
        selectButton: this.buttonsFormGroup(),
        goBackButton: this.buttonsFormGroup(),
        outlineColour: this.buttonsFormGroup(),
        buttonBreakValueTitle: new FormControl('How would you like your offer broken down?'),
        font: this.formService.generateTextInputsConfig()
      }),
      mysteryOffer: this.createMysteryOffer(),
      riskOffer: this.createRiskOffer(),
      chooseOffer: this.createChooseOffer(),
      swapOffer: this.createSwapOffer(),
      swapOfferCms: this.createSwapOfferCms(),
      voucher: this.fb.group({
        type: new FormControl(VOUCHER_TYPES[0]),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),
        html: new FormControl(
          VOUCHER_HTML(this.authService.userData.clientName)
        ),
        cmsHtml: new FormControl(
          CMS_VOUCHER_HTML(this.authService.userData.clientName)
        ),
      }),
    });
  }

  public createOffersAndDrawingsTemplateConfiguration() {
    return this.fb.group({
      main: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        noItemsText: new FormControl('There are currently no items available.'),
        noItems: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
      }),
      cardDrawing: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(true),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivateDisabled: this.formService.buttonFormGroup(),
        buttonActivateDisabledText: new FormControl('Activate'),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardFreeEntry: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardTierEntry: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardMultiplier: this.fb.group({
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        shadow: this.formService.shadowFormGroup(),
        buttonDetail: this.formService.buttonFormGroup(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      drawingDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),

         closeButtonCheck: this.fb.group({
        isOnOffMode: new FormControl(false),
        }),

        title: this.formService.generateTextInputsConfig(),
        date: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
        sliderButtonActivate: this.formService.buttonFormGroup(),
        sliderButtonInactive: this.formService.buttonFormGroup(),
        sliderText: this.formService.generateTextInputsConfig(),
      }),
      freeEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      tierEntryDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      multiplierDetails: this.fb.group({
        closeButton: this.formService.buttonFormGroup(),
        title: this.formService.generateTextInputsConfig(),
        description: this.formService.generateTextInputsConfig(),
        background: this.formService.backgroundFormGroup(),
        imageBorder: this.formService.borderFormGroup(),
        detailBackground: this.formService.backgroundFormGroup(),
        detailBorder: this.formService.borderFormGroup(),
        detailEntry: this.formService.generateTextInputsConfig(),
        detailText: this.formService.generateTextInputsConfig(),
        buttonActivate: this.formService.buttonFormGroup(),
        buttonActivated: this.formService.buttonFormGroup(),
      }),
      cardOffer: this.createCardOffer(),
      cardOfferDetails: this.createCardOfferDetails(),
      mysteryOffer: this.createMysteryOffer(),
      riskOffer: this.createRiskOffer(),
      chooseOffer: this.createChooseOffer(),
      swapOffer: this.createSwapOffer(),
      voucher: this.fb.group({
        type: new FormControl(VOUCHER_TYPES[0]),
        html: new FormControl(
          VOUCHER_HTML(this.authService.userData.clientName)
        ),
        advPrint: this.fb.group({
          isEnabled: new FormControl(false),
          kioskDeviceIds: new FormControl(''),
        }),
      }),
      welcomePopUp: this.fb.group({
        isEnabled: new FormControl(false),
        schedule: new FormControl('0'),
        weekdaySchedule: this.fb.group({
          isEnabled: new FormControl(false),
          selectedDays: new FormControl([]),
        }),
        background: this.formService.backgroundFormGroup(),
        border: this.formService.borderFormGroup(),
        message: new FormControl(''),
        messageStyle: this.formService.generateTextInputsConfig(),
        buttonText: new FormControl(''),
        button: this.formService.buttonFormGroup(),
      }),
    });
  }

  private createCardOffer(): FormGroup {
    return this.fb.group({
      title: this.formService.generateTextInputsConfig(),
      upcomingOfferTitleColor: new FormControl(null),
      diagonalLabelButton: this.buttonsFormGroup(),

      background: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
      border: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      buttonOfferDetailsText: new FormControl('Offer detail'),
      buttonOfferDetails: this.buttonsFormGroup(),
    });
  }

  private createChooseOffer(): FormGroup {
    return this.fb.group({
      buttonContinueChooseRewardText: new FormControl('Continue'),
      buttonContinueChooseReward: this.buttonsFormGroup(),
      buttonContinueDisableChooseReward: this.buttonsFormGroup(),
      headerChooseRewardText: new FormControl('Select your new offer:'),
      headerChooseReward: this.formService.generateTextInputsConfig(),
      confirmedChooseRewardText: new FormControl('Confirmed'),
      confirmedChooseReward: this.formService.generateTextInputsConfig(),
      activeImageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      inactiveImageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
        confirmedIconChooseReward: this.fb.group({
        iconName: new FormControl(''),
        iconColor: new FormControl(null),
        iconSize: new FormControl(null),
      }),
    });
  }

  private createMysteryOffer(): FormGroup {
    return this.fb.group({
      headerClaimMysteryPrizeText: new FormControl('How to Redeem'),
      headerClaimMysteryPrizeTitle: this.formService.generateTextInputsConfig(),
      instructionClaimMysteryPrizeText: new FormControl(
        'Print this offer and bring it to the Loyalty Desk to reveal your prize.'
      ),
      instructionClaimMysteryPrizeDescription:
        this.formService.generateTextInputsConfig(),
      buttonClaimMysteryPrizeText: new FormControl('Claim Mystery Prize'),
      buttonClaimMysteryPrize: this.buttonsFormGroup(),
      buttonOkClaimMysteryPrizeText: new FormControl('OK'),
      buttonOkClaimMysteryPrize: this.buttonsFormGroup(),
      imageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      title: this.formService.generateTextInputsConfig(),
      text: this.formService.generateTextInputsConfig(),
      okTitleText: new FormControl('Congrats!'),
      okTextText: new FormControl('You won a offer -'),
      okTitle: this.formService.generateTextInputsConfig(),
      okText: this.formService.generateTextInputsConfig(),
    });
  }

  private createRiskOffer(): FormGroup {
    return this.fb.group({
      headerRiskText: new FormControl('How to Redeem'),
      headerRiskTitle: this.formService.generateTextInputsConfig(),
      instructionRiskText: new FormControl(
        'Print this offer and bring it to any table game to use.'
      ),
      instructionRiskDescription: this.formService.generateTextInputsConfig(),
      buttonRiskText: new FormControl('Risk this offer'),
      buttonRisk: this.buttonsFormGroup(),
      buttonRiskPrintText: new FormControl('Print offer'),
      buttonRiskPrint: this.buttonsFormGroup(),
      buttonRiskRedeemText: new FormControl('Print offer'),
      buttonRiskRedeem: this.buttonsFormGroup(),
      imageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      title: this.formService.generateTextInputsConfig(),
      text: this.formService.generateTextInputsConfig(),
      headerConfirmRiskText: new FormControl('Do you want to risk this offer?'),
      headerConfirmRisk: this.formService.generateTextInputsConfig(),
      confirmRiskTextText: new FormControl(
        'Could be a better deal waiting… or maybe not. Do you dare to go for more?'
      ),
      confirmRiskText: this.formService.generateTextInputsConfig(),

      buttonConfirmRiskText: new FormControl('Risk offer'),
      buttonConfirmRisk: this.buttonsFormGroup(),
      buttonKeepRiskText: new FormControl('Keep offer'),
      buttonKeepRisk: this.buttonsFormGroup(),
      buttonKeepRiskOkText: new FormControl('Ok'),
      buttonKeepRiskOk: this.buttonsFormGroup(),

      headerEmptyRiskText: new FormControl('Better luck next time!'),
      headerEmptyRisk: this.formService.generateTextInputsConfig(),
      emptyRiskTextText: new FormControl(
        'You risked your offer and did not win anything.'
      ),
      emptyRiskText: this.formService.generateTextInputsConfig(),
      buttonEmptyRiskText: new FormControl('Ok'),
      buttonEmptyRisk: this.buttonsFormGroup(),

      buttonRedeemRiskText: new FormControl('Redeem'),
      buttonRedeemRisk: this.buttonsFormGroup(),
    });
  }

  private createCardOfferDetails(): FormGroup {
    return this.fb.group({
      closeButton: this.formService.buttonFormGroup(),
      isCloseOnOffMode: new FormControl(true),
      title: this.formService.generateTextInputsConfig(),
      upcomingOfferTitleColor: new FormControl(null),
      text: this.formService.generateTextInputsConfig(),
      background: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
      buttonPrintOfferText: new FormControl('Print'),
      buttonRedeemOfferText: new FormControl('Redeem'),
      buttonMultiplierText: new FormControl('Multiplier'),
      buttonBreakValueText: new FormControl('Break Value'),
      buttonPrintOffer: this.buttonsFormGroup(),
      redeemOfferButton: this.buttonsFormGroup(),
      buttonBreakValue: this.buttonsFormGroup(),
      buttonPrintRedeemOfferInactive: this.buttonsFormGroup(),
      buttonPrintedOfferText: new FormControl('Printed'),
      buttonRedeemedOfferText: new FormControl('Redeemed'),
      buttonMultiplierClaimedText: new FormControl('Claimed'),
      validTillPrefix: new FormControl('Valid till:'),
      qrCodeBackground: this.fb.group({
        color: new FormControl(null),
        imageLink: new FormControl(null),
        imageName: new FormControl(null),
      }),
      border: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
      qrCodeText: this.formService.generateTextInputsConfig(),
      imageBorder: this.fb.group({
        borderColor: new FormControl(null),
        borderRadius: new FormControl(null),
        borderWidth: new FormControl(null),
      }),
    });
  }

  private createDefaultOfferConfiguration() {
    return {
      displayType: new FormControl('Icons'),
      configuration: new FormControl('Square'),
      lobbyToken: new FormControl(null, Validators.required),
      filterByCriteria: new FormControl(null),
      filterByTreshold: new FormControl(null),
      sorting: new FormControl('0'),
      isNeedToCloseAfterPrint: new FormControl(true),
      hideExpiredCampaigns: new FormControl(false)
    };
  }
}
